import CryptoJS from "crypto-js";
import { JSEncrypt } from "jsencrypt";


// RSA Public & Private Keys (Replace with actual keys)
const PUBLIC_KEY = process.env.REACT_APP_PUBLIC_KEY;  // Your RSA Public Key
const AES_KEY = process.env.REACT_APP_AES_KEY; // Your AES Key

// Generate a random 256-bit AES key
const generateAESKey = () => {
	return CryptoJS.lib.WordArray.random(32).toString(CryptoJS.enc.Hex); // 256-bit AES key
};

// Encrypt payload with AES
const encryptWithAES = (text, aesKey) => {
	return CryptoJS.AES.encrypt(JSON.stringify(text), aesKey).toString();
};

// Generate HMAC-SHA256 for integrity
const generateHMAC = (message, secretKey) => {
	return CryptoJS.HmacSHA256(message, secretKey).toString(CryptoJS.enc.Hex);
};

// Encrypt AES key using RSA Public Key
const encryptAESKeyWithRSA = (aesKey) => {
	const encrypt = new JSEncrypt();
	// console.log("Public Key:", PUBLIC_KEY); // Log the public key for debugging
	encrypt.setPublicKey(PUBLIC_KEY);
	return encrypt.encrypt(aesKey);
};

// Read file to base64
const readFileAsBase64 = (file) => {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onload = () => resolve(reader.result.split(',')[1]);
		reader.onerror = reject;
		reader.readAsDataURL(file);
	});
};

// Encrypt request data and prepare headers
const encryptRequestData = (payload) => {
	// console.log("Payload to encrypt:", payload); // Log the payload for debugging
	// const aesKey = generateAESKey();
	const aesKey = AES_KEY;
	const encryptedPayload = encryptWithAES(payload, aesKey);
	const encryptedAESKey = encryptAESKeyWithRSA(aesKey);
	const hmacToken = generateHMAC(JSON.stringify(payload), aesKey);

	return {
		body: { data: encryptedPayload },
		headers: {
			"X-AES-KEY": encryptedAESKey,
			"X-HMAC-TOKEN": hmacToken
		}
	};
};

/**
 * Securely prepares FormData with encrypted JSON and optional image
 * @param {object} payload - The JSON data to send
 * @param {File | null} file - Optional image file
 * @returns {{ formData: FormData, headers: object }}
 */
// const prepareSecureFormData = async (payload, file = null) => {
const prepareSecureFormData = async (payload = null, files = []) => {
	const aesKey = AES_KEY;
	const encryptedAESKey = encryptAESKeyWithRSA(aesKey);
	const formData = new FormData();
	// console.log(payload)
	// Add encrypted payload if available
	if (payload) {
		const encryptedPayload = encryptWithAES(payload, aesKey);
		formData.append("data", encryptedPayload);
	}

	// Generate HMAC if payload is present
	const hmacToken = payload ? generateHMAC(JSON.stringify(payload), aesKey) : "";

	// Encrypt files
	if (files.length > 0) {
		for (let i = 0; i < files.length; i++) {
			const item = files[i];
			const file = item.file || item; // If no `.file` key, assume `item` is file directly
			// const type = item.type || null; // Optional
			const hasCustomType = item.hasOwnProperty("type"); // <--- KEY CHANGE

			const base64File = await readFileAsBase64(file);
			const encryptedFile = CryptoJS.AES.encrypt(base64File, aesKey).toString();
			const blob = new Blob([encryptedFile], { type: "text/plain" });

			// Conditionally set key
			if (hasCustomType) {
				const typeKey = item.type || "default";
				formData.append(`attachments[${typeKey}]`, blob, file.name);
				// console.log(`attachments[${typeKey}]`, blob, file.name); // Debugging log
			} else {
				formData.append("attachments[]", blob, file.name);
				// console.log("attachments[]", blob, file.name); // Debugging log
			}
		}
	}

	// Return both formData and custom headers
	return {
		formData,
		headers: {
			"X-AES-KEY": encryptedAESKey,
			"X-HMAC-TOKEN": hmacToken,
		}
	};
};

// Export functions
export { encryptRequestData, prepareSecureFormData, encryptAESKeyWithRSA };
